(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["signology-order-demo"] && !Shopify.designMode) return;
  try {
    function createSignologyDemoEngine() {
  const DAY_MS = 86400000;
  const EPOCH_MS = Date.UTC(2026, 0, 1);
  const BASE_TOTAL = 100000;
  const prefixes = [0];
  const schedules = new Map();

  function mix(value) {
    let x = value >>> 0;
    x = Math.imul(x ^ (x >>> 16), 0x21f0aaad);
    x = Math.imul(x ^ (x >>> 15), 0x735a2d97);
    return (x ^ (x >>> 15)) >>> 0;
  }

  function validateDay(day) {
    if (!Number.isSafeInteger(day) || day < 0) {
      throw new RangeError('Day must be a nonnegative safe integer.');
    }
  }

  function randomForDay(day) {
    let state = mix(day ^ 0x6e34ca21);
    return function () {
      state = (state + 0x6d2b79f5) >>> 0;
      let value = state;
      value = Math.imul(value ^ (value >>> 15), value | 1);
      value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
      return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
    };
  }

  function targetForDay(day) {
    validateDay(day);
    return 801 + mix(day ^ 0x4893bc17) % 113;
  }

  function scheduleForDay(day) {
    validateDay(day);
    if (schedules.has(day)) return schedules.get(day);
    const random = randomForDay(day);
    const usedOffsets = new Set();
    const events = [];
    let remaining = targetForDay(day);
    while (remaining > 0) {
      const size = Math.min(remaining, 1 + Math.floor(random() * 5));
      let offset;
      do {
        offset = 1 + Math.floor(random() * (DAY_MS - 1));
      } while (usedOffsets.has(offset));
      usedOffsets.add(offset);
      events.push({ offset, size });
      remaining -= size;
    }
    events.sort((a, b) => a.offset - b.offset);
    let cumulative = 0;
    const schedule = Object.freeze(events.map(event => {
      cumulative += event.size;
      return Object.freeze({ offset: event.offset, size: event.size, cumulative });
    }));
    if (schedules.size >= 8) schedules.delete(schedules.keys().next().value);
    schedules.set(day, schedule);
    return schedule;
  }

  function cumulativeBefore(day) {
    while (prefixes.length <= day) {
      const nextDay = prefixes.length - 1;
      prefixes.push(prefixes[nextDay] + targetForDay(nextDay));
    }
    return prefixes[day];
  }

  function snapshot(timestamp) {
    if (!Number.isFinite(timestamp) || Math.abs(timestamp) > 8640000000000000) {
      throw new RangeError('A finite timestamp within the JavaScript date range is required.');
    }
    const effective = Math.max(EPOCH_MS, Math.floor(timestamp));
    const day = Math.floor((effective - EPOCH_MS) / DAY_MS);
    const withinDay = (effective - EPOCH_MS) % DAY_MS;
    const events = scheduleForDay(day);
    let low = 0;
    let high = events.length;
    while (low < high) {
      const middle = Math.floor((low + high) / 2);
      if (events[middle].offset <= withinDay) low = middle + 1;
      else high = middle;
    }
    const today = low === 0 ? 0 : events[low - 1].cumulative;
    let lastEvent = null;
    if (low > 0) {
      lastEvent = EPOCH_MS + day * DAY_MS + events[low - 1].offset;
    } else if (day > 0) {
      const previous = scheduleForDay(day - 1);
      lastEvent = EPOCH_MS + (day - 1) * DAY_MS + previous[previous.length - 1].offset;
    }
    return Object.freeze({
      today,
      yesterday: day > 0 ? targetForDay(day - 1) : 0,
      total: BASE_TOTAL + cumulativeBefore(day) + today,
      lastEvent,
      timestamp: effective,
      day,
      target: targetForDay(day)
    });
  }

  return Object.freeze({ snapshot, targetForDay, scheduleForDay, EPOCH_MS, DAY_MS, BASE_TOTAL });
}


  if (!customElements.get('signology-order-demo')) {
    customElements.define('signology-order-demo', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initializeDemo());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearInterval(this.timer);
        this.abort?.abort();
        this.ready = false;
      }
      initializeDemo() {
        if (this.ready || !this.isConnected) return;
        this.ready = true;
        this.engine = createSignologyDemoEngine();
        this.abort = new AbortController();
        this.nodes = Object.fromEntries(['total', 'today', 'yesterday', 'latest', 'clock', 'preview', 'status'].map(key => [key, this.querySelector('[data-' + key + ']')]));
        this.fast = false;
        this.anchorTime = Date.now();
        this.anchorPerformance = performance.now();
        this.lastTime = null;
        this.previousTotal = null;
        this.nodes.preview.textContent = this.dataset.previewLabel;
        this.nodes.preview.setAttribute('aria-pressed', 'false');
        this.nodes.status.textContent = this.dataset.normalStatus;
        try { this.formatter = new Intl.DateTimeFormat(this.dataset.locale || 'en', { timeZone: 'UTC', hour: 'numeric', minute: '2-digit', second: '2-digit' }); }
        catch { this.formatter = new Intl.DateTimeFormat('en', { timeZone: 'UTC', hour: 'numeric', minute: '2-digit', second: '2-digit' }); }
        this.nodes.preview.addEventListener('click', () => {
          this.fast = !this.fast;
          this.anchorTime = Date.now();
          this.anchorPerformance = performance.now();
          this.lastTime = null;
          this.nodes.preview.textContent = this.fast ? this.dataset.normalLabel : this.dataset.previewLabel;
          this.nodes.preview.setAttribute('aria-pressed', String(this.fast));
          this.nodes.status.textContent = this.fast ? this.dataset.fastStatus : this.dataset.normalStatus;
          this.renderDemo();
        }, { signal: this.abort.signal });
        document.addEventListener('visibilitychange', () => { if (!document.hidden) this.renderDemo(); }, { signal: this.abort.signal });
        this.renderDemo();
        this.timer = setInterval(() => this.renderDemo(), 500);
      }
      renderDemo() {
        const timestamp = this.fast ? this.anchorTime + (performance.now() - this.anchorPerformance) * 60 : Date.now();
        if (!this.fast && this.lastTime !== null && timestamp < this.lastTime - 2000) this.nodes.status.textContent = this.dataset.clockChange;
        this.lastTime = timestamp;
        const sample = this.engine.snapshot(timestamp);
        for (const key of ['total', 'today', 'yesterday']) {
          const formatted = sample[key].toLocaleString(this.dataset.locale || 'en');
          const node = this.nodes[key];
          if (node.textContent !== formatted) {
            node.textContent = formatted;
            if (this.previousTotal !== null && key !== 'yesterday') {
              node.classList.remove('sg-order-demo__changed');
              void node.offsetWidth;
              node.classList.add('sg-order-demo__changed');
            }
          }
        }
        const seconds = sample.lastEvent === null ? null : Math.floor((sample.timestamp - sample.lastEvent) / 1000);
        this.nodes.latest.textContent = seconds === null ? this.dataset.notYet : seconds < 2 ? this.dataset.justNow : seconds < 60 ? seconds + this.dataset.seconds : Math.floor(seconds / 60) + this.dataset.minutes + ' ' + String(seconds % 60).padStart(2, '0') + this.dataset.seconds;
        this.nodes.clock.textContent = this.formatter.format(new Date(sample.timestamp)) + ' UTC';
        this.previousTotal = sample.total;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
